import { atom, selector } from 'recoil';
import { IdCardDto } from '@/model/idCard.dto';

export const idCardListRecoil = atom<IdCardDto[] | null>({
  key: 'idCardListRecoil',
  default: null,
});

export const idCardListLengthRecoil = atom<number | undefined>({
  key: 'idCardListLengthRecoil',
  default: 0,
});

export const idCardModifyNumRecoil = atom<number | null>({
  key: 'idCardModifyNumRecoil',
  default: null,
});

export const idCardModifyRecoil = selector<IdCardDto | null>({
  key: 'idCardModifyRecoil',
  get: ({ get }) => {
    const list = get(idCardListRecoil);
    const modifyNum = get(idCardModifyNumRecoil);
    if (list && modifyNum !== null) {
      return list.find((item) => item.id === modifyNum) || null;
    } else {
      return null;
    }
  },
});
